import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';
import PaymentInformation from '@views/ManageAccount/Payment/PaymentInformation';

const messages = defineMessages({
  title: {
    id: 'manageAccount.paymentBilling',
    defaultMessage: 'Payment and Billing',
  },
});

export default function UpdatePaymentBilling(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ account, loading }) => (
        <PaymentInformation account={account} loading={loading} />
      )}
    </ManageAccountLayout>
  );
}
